import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select from "react-select";
import SelectField from "../../../../../../../SelectField";
import PGAModelBuilderInput from "../../../PGAModelBuilderInput";

const GET_CALC_OPTIONS = graphql`
  query PGAModelBuilderCalcTabCalculationSelectQuery($classificationID: ID!) {
    pgaModelCalculations(classificationId: $classificationID) {
      id
      name
    }
  }
`;

export default function PGAModelBuilderCalcTabCalculationSelect(props) {
  let options = [];
  if (props.selectedClassification) {
    const data = useLazyLoadQuery(GET_CALC_OPTIONS, {
      classificationID: props.selectedClassification
        ? props.selectedClassification.value
        : undefined,
    });

    options = data.pgaModelCalculations.map((calculation) => {
      return {
        value: calculation.id,
        label: calculation.name,
      };
    });
  }

  return (
    <div style={{ width: "100%", flex: "2 2 0" }}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>
        Calculation
        <Select
          options={options}
          onChange={(selected) => {
            props.setSelectedCalculation(selected);
          }}
          value={props.selectedCalculation}
        />
      </label>
    </div>
  );
}
